import { creators, types } from './actions.js';
export { creators, types } from './actions.js';
import reducer, { initialState } from './reducer.js';
export { initialState, default as reducer } from './reducer.js';
import sagas from './sagas/index.js';
export { default as sagas } from './sagas/index.js';
import takes from './takes.js';
export { default as takes } from './takes.js';
import selectors from './selectors.js';

var store = 'featureFlags';
var FeatureFlags = function FeatureFlags(_ref) {
  var createDuck = _ref.createDuck;
  return createDuck({
    store: store,
    initialState: initialState
  }).extend({
    creators: creators,
    types: types,
    reducer: reducer,
    sagas: sagas,
    takes: takes,
    selectors: selectors
  });
};

export { FeatureFlags, store };
//# sourceMappingURL=index.js.map
